import React from 'react';
import {StandardProps} from '..';

export type VisibilityHoverIconButtonProps = StandardProps<React.HTMLAttributes<HTMLOrSVGElement>>;

export function VisibilityHoverIconButton(props: VisibilityHoverIconButtonProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <path d="M16 23C10.004 23 6.22728 19.893 4.37409 17.819C3.4304 16.7628 3.4304 15.2372 4.37409 14.181C6.22728 12.107 10.004 9 16 9C21.996 9 25.7727 12.107 27.6259 14.181C28.5696 15.2372 28.5696 16.7628 27.6259 17.819C25.7727 19.893 21.996 23 16 23Z" fill="#CACBCE" />
      <circle cx="16" cy="16" r="3" fill="#474856" />
    </svg>
  );
}

export default VisibilityHoverIconButton;